module.exports = __webpack_public_path__ + "static/img/album4_202601_03.6d46b0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/fight-epidemic/album4_202601_03.jpg
// module id = fXWr
// module chunks = 100